import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESS_SETTINGS_REQUEST = 'BUSINESS_SETTINGS_REQUEST'
export const BUSINESS_SETTINGS_SUCCESS = 'BUSINESS_SETTINGS_SUCCESS'
export const BUSINESS_SETTINGS_FAILURE = 'BUSINESS_SETTINGS_FAILURE'
export const BUSINESS_SETTINGS_RESET = 'BUSINESS_SETTINGS_RESET'

export const fetchBusinessSettings = (id) => ({
  [CALL_API]: {
    endpoint: '/api/business/businesses/' + id + '/config/',
    types: [BUSINESS_SETTINGS_REQUEST, BUSINESS_SETTINGS_SUCCESS, BUSINESS_SETTINGS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export function resetFetchBusinessById() {
  return {
    type: BUSINESS_SETTINGS_RESET,
  }
}
